import React, { createRef } from 'react';
import SectionGroup from 'app/components/general/SectionGroup';
import SchemaForm from 'app/components/general/SchemaForm';
import { Link } from 'react-router-dom';
import { Badge } from 'reactstrap';

import Alert from 'app/components/general/Alert';
import PaymentCardMin from 'app/components/matches/PaymentCardMin';

import requestPaymentTypes from 'app/utils/static/requestPaymentTypes';
import collectCategories from 'app/utils/static/collectCategories';
import splitTypes from 'app/utils/static/splitTypes';
import * as paymentEventsSelectors from 'app/ducks/paymentEvents/selectors';
import Loader from 'app/components/general/Loader';

const uiSchema = {
  root: { classNames: 'row' },
  paymentType: { 'ui:field': 'select', classNames: '' },
  splitType: { 'ui:field': 'select', classNames: 'col-5' },
  amount: { 'ui:field': 'currency', classNames: 'col-7' },
  dueDate: { 'ui:field': 'datetime', classNames: '' },
};

interface IStep1PaymentDetailProps {
  isValid: Function;
  handleChange: Function;
  handleError: Function;
  handleSubmit: Function;
  formData: any;
  errors: any;
  changed: boolean;
  teamMembersLoaded: boolean;
  amountDescription: string;
  teamPaymentRequests: any;
  originalFormData: any;
  users: any;
  currentPaymentEvent: any;
  groupId: string;
}

export default class Step1PaymentDetail extends React.Component<IStep1PaymentDetailProps> {
  static defaultProps: IStep1PaymentDetailProps = {
    formData: undefined,
    changed: false,
    teamPaymentRequests: undefined,
    originalFormData: undefined,
    isValid: undefined,
    amountDescription: '',
    handleChange: undefined,
    handleError: undefined,
    handleSubmit: undefined,
    errors: undefined,
    users: undefined,
    currentPaymentEvent: undefined,
    groupId: undefined,
  };

  render(): React.ReactNode {
    const formSchema = {
      type: 'object',
      required: ['paymentType',
        'description',
        'amount',
        'dueDate'],
      properties: {
        paymentType: {
          type: ['object', 'null'],
          title: 'Payment Category',
          options: collectCategories,
          inputType: 'select',
          clearable: false,
          createable: true,
        },
        description: {
          type: 'string',
          maxLength: 80,
          minLength: 1,
          title: 'Payment Description (this is what team members will see in their payment request)',
        },
        dueDate: {
          type: 'array',
          items: {
            type: 'string',
          },
          enableTime: false,
          inputType: 'datetime',
          title: 'Due Date',
        },
        splitType: {
          type: ['object', 'null'],
          title: 'Split Type',
          options: splitTypes,
          inputType: 'select',
          clearable: false,
          createable: false,
        },
        amount: {
          type: 'string',
          inputType: 'currency',
          title: `Amount ${this.props.amountDescription}`,
        },
      },
    };
    if (!this.props.teamMembersLoaded) {
      return (
        <Loader
          skeleton
          isActive
        />
      );
    }

    return (
      <div>
        <div className="row">
          <div className="col">
            {this.props.children}
          </div>
        </div>
        {!_.isEmpty(this.props.currentPaymentEvent) && !_.isEmpty(this.props.groupId) && (
          <div className="row with-margin-bottom with-margin-top">
            <div className="col">
              <SectionGroup title="Selected Match">
                <div className="row">
                  <div className="col">
                    <PaymentCardMin
                      {...paymentEventsSelectors.getPaymentEventForMatchCard(
                        this.props.currentPaymentEvent,
                        this.props.groupId,
                      )}
                      truncated
                    />
                  </div>
                </div>

              </SectionGroup>
            </div>
          </div>
        )}
        {_.isEmpty(this.props.users.currentUser.bankAccount.id) && (
          <div className="row with-margin-top">
            <div className="col">

              <Alert color="warning" className="with-margin-bottom-10">
                <div className="d-inline-block">
                  <h4>
                    No bank account attached to your Teammo account
                  </h4>
                  <span className="with-margin-top">
                    You may request funds from team members, but you will not
                    receive funds.
                    {' '}
                    <Link to="/profile/bank">Add a bank account</Link>
                  </span>
                </div>
              </Alert>
            </div>
          </div>
        )}
        <div className="row with-margin-top-extra">
          <div className="col">
            <SectionGroup title="Payment Details">
              <div className="form-description">
                You can collect payment from people or teams and have the money
                sent directly to your bank account.
              </div>
              <SchemaForm
                uiSchema={uiSchema}
                schema={formSchema}
                handleChange={this.props.handleChange}
                handleError={this.props.handleError}
                handleSubmit={this.props.handleSubmit}
                formData={this.props.formData}
                errors={this.props.errors}
                liveValidate={false}
                // isValid={this.props.isValid()}
                isLoading={this.props.teamPaymentRequests.isSaving}
                hasSaved={this.props.teamPaymentRequests.hasSaved}
                hasFailed={this.props.teamPaymentRequests.hasFailed}
                originalFormData={this.props.originalFormData}
                buttonText="Next"
              >
                <div className="row with-margin-bottom">
                  <div className="col">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-0">
                        <Badge color="blue" className="small with-margin-right">Fee</Badge>
                      </div>
                      <div className="flex-grow-1 form-description">
                        A
                        {' '}
                        <strong>1.9% + $0.20</strong>
                        {' '}
                        service fee is charged to each team
                        member, on top of the amount you request.
                      </div>
                    </div>
                  </div>
                </div>
              </SchemaForm>
            </SectionGroup>
          </div>
        </div>

      </div>
    );
  }
}
